/* @flow */
import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { Router, browserHistory } from 'react-router';
import { IntlProvider } from 'react-intl';

import { UserAgentProvider, windowStr } from 'lib/currentUserAgent';
import * as zopim from 'lib/zopimListener';

import routes from '../routes';

export default class Root extends React.Component<{ apolloClient: *, reduxStore: * }> {
  componentWillMount() {
    zopim.listenForStatusChange(this.props.reduxStore.dispatch);
  }

  render() {
    const { apolloClient, reduxStore } = this.props;

    return (
      <IntlProvider locale="en">
        <Provider store={reduxStore}>
          <ApolloProvider store={reduxStore} client={apolloClient}>
            <UserAgentProvider userAgentSpec={windowStr}>
              <CookiesProvider>
                <Router history={browserHistory}>{routes}</Router>
              </CookiesProvider>
            </UserAgentProvider>
          </ApolloProvider>
        </Provider>
      </IntlProvider>
    );
  }
}
